module.exports = __webpack_public_path__ + "static/media/leather_ladies_strap_tan.ef462473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leather_ladies_strap_tan.png
// module id = 120
// module chunks = 0